import { render } from "./icon-big-eye.vue?vue&type=template&id=2c9ea6f4&ts=true"
import script from "./icon-big-eye.vue?vue&type=script&lang=ts"
export * from "./icon-big-eye.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__